const config = {
  "splash": false,
  "siteName": "JueJin | ByteDream",
  "siteDescription": "Yet Another Blog In JueJin Style By ByteDream",
  "siteUrl": "https://bytedream.top",
  "titleSeparator": "·",
  "trailingSlash": false,
  "language": "zh-CN",
  "indexable": true
};
export default config